<div class="content">
  <div class="content-panel">
    @if (formGroup) {
      <form
        [formGroup]="formGroup"
        #form="ngForm"
        (submit)="submit()"
        novalidate
        t-id="habilitation-update-form"
      >
        <!-- Formulaire sur le type -->
        <h5>Type d'organisme :</h5>
        <div class="flex-break"></div>
        <ng-container
          *ngTemplateOutlet="
            fieldSelect;
            context: {
              form: form,
              formControl: type,
              placeholder: 'type',
              items: typesOrganismes,
              required: true
            }
          "
        ></ng-container>
        <div class="flex-break"></div>

        <!-- Formulaire identité -->
        <h5>Identité :</h5>
        <div class="flex-break"></div>

        <ng-container
          *ngTemplateOutlet="
            fieldUpload;
            context: {
              form: form,
              formControl: logo,
              placeholder: 'logo',
              items: logo
            }
          "
        ></ng-container>

        <div class="flex-break"></div>

        <ng-container
          *ngTemplateOutlet="
            fieldSelect;
            context: {
              form: form,
              formControl: structure,
              placeholder: 'structure',
              items: structures
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: raisonSociale,
              placeholder: 'raisonSociale',
              required: true
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: siret,
              placeholder: 'siret'
            }
          "
        ></ng-container>

        <div class="flex-break"></div>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: adresse,
              placeholder: 'adresse',
              isArea: true
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: codePostal,
              placeholder: 'codePostal'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: ville,
              placeholder: 'ville'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldSelect;
            context: {
              form: form,
              formControl: pays,
              items: listePays,
              placeholder: 'pays'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: cedex,
              placeholder: 'cedex'
            }
          "
        ></ng-container>

        <div class="flex-break"></div>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: telephone,
              placeholder: 'telephone'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: portable,
              placeholder: 'portable'
            }
          "
        ></ng-container>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: fax,
              placeholder: 'fax'
            }
          "
        ></ng-container>

        <div class="flex-break"></div>

        <ng-container
          *ngTemplateOutlet="
            fieldText;
            context: {
              form: form,
              formControl: mail,
              placeholder: 'mail'
            }
          "
        ></ng-container>

        <div class="flex-break"></div>

        <div id="button-next-cnt">
          <button type="submit" class="btn btn-primary" translate>
            @if (canEditAbonnements && !canModifyOrganisme) {
              label.suivant
            } @else {
              label.enregistrer
            }
          </button>
        </div>
      </form>
    }
  </div>
</div>

<ng-template
  #fieldSelect
  let-form="form"
  let-formControl="formControl"
  let-label="label"
  let-items="items"
  let-placeholder="placeholder"
  let-required="required"
>
  <div class="mb-3">
    @if (label) {
      <label class="form-label" [for]="formControl.name">
        {{ 'page.admin.organismes.edit.label.' + label | translate }}
      </label>
    }

    <select
      [id]="formControl.name"
      [formControl]="formControl"
      [required]="required"
      [ngClass]="{
        'is-invalid': form.submitted && formControl.invalid,
        'select-placeholder': formControl.value === null && !formControl.dirty
      }"
      class="form-control"
    >
      @if (placeholder) {
        <option [ngValue]="null" hidden>
          {{ 'page.admin.organismes.edit.label.' + placeholder | translate }}
        </option>
      }

      @for (item of items; track item) {
        <option [ngValue]="item">{{ item.libelle }}</option>
      }
    </select>

    @if (form.submitted && required && formControl.errors?.required) {
      <div class="form-error" translate>label.obligatoire</div>
    }
  </div>
</ng-template>

<ng-template
  #fieldText
  let-form="form"
  let-isArea="isArea"
  let-formControl="formControl"
  let-label="label"
  let-placeholder="placeholder"
  let-required="required"
>
  <div class="mb-3">
    @if (label) {
      <label class="form-label" [for]="formControl.name">
        {{ 'page.admin.organismes.edit.label.' + label | translate }}
      </label>
    }

    @if (!isArea) {
      <input
        type="text"
        [id]="formControl.name"
        [formControl]="formControl"
        [required]="required"
        [ngClass]="{ 'is-invalid': form.submitted && formControl.invalid }"
        class="form-control"
        [placeholder]="
          placeholder
            ? ('page.admin.organismes.edit.label.' + placeholder | translate)
            : ''
        "
      />
    } @else {
      <textarea
        [id]="formControl.name"
        [formControl]="formControl"
        [required]="required"
        [ngClass]="{ 'is-invalid': form.submitted && formControl.invalid }"
        class="form-control"
        [placeholder]="
          placeholder
            ? ('page.admin.organismes.edit.label.' + placeholder | translate)
            : ''
        "
      ></textarea>
    }

    @if (form.submitted && required && formControl.errors?.required) {
      <div class="form-error" translate>label.obligatoire</div>
    }
  </div>
</ng-template>

<ng-template
  #fieldUpload
  let-formControl="formControl"
  let-label="label"
  let-required="required"
>
  <div class="mb-3">
    @if (formControl?.value) {
      <div class="imagePreview mb-2">
        <img
          alt="Logo"
          [src]="formControl.value"
          style="max-width: 100px; max-height: 38px; margin-left: 10px;"
        />
      </div>
    }

    @if (label) {
      <label class="form-label d-block">
        {{ 'page.admin.organismes.edit.label.' + label | translate }}
      </label>
    }

    <label class="btn btn-outline-secondary mb-0">
      Choisir un fichier
      <input
        type="file"
        class="d-none"
        (change)="onFileSelected($event)"
      />
    </label>

    @if (required && formControl.errors?.required && formControl.touched) {
      <div class="form-error" translate>label.obligatoire</div>
    }
  </div>
</ng-template>
